export {
  getHost,
  redirectToSubdomain,
  getHeaderValue,
  withoutStartingSlash,
} from './connection';
export { getExternalRedirectResult } from './redirect';
